export default (tourCriteria) => {
    const params = {};
    const element = tourCriteria.get('countries');
    if (element && element.length) {
        [params.toCountry] = element.pluck('id');
    }

    return params;
};